import React from 'react';
import styled, { css } from 'styled-components';
import { spacing } from 'ui';
import { useBreakpoint } from '../hooks';

const ScrollContainer = styled.div`
   overflow: hidden;
   margin-right: ${spacing()};
   flex: 1;
   ${props =>
      props.isMobile &&
      css`
         margin-top: -1rem;
         margin-bottom: 1rem;
      `};
`;

const TextCapitalize = styled.span`
   color: red;
   font-weight: bold;
   font-size: large;
`;

const ScrollText = styled.p`
    white-space: nowrap;
    -moz-transform: translateX(100%);
    -webkit-transform: translateX(100%);
    transform: translateX(100%);

    -moz-animation: my-animation 25s linear infinite;
    -webkit-animation: my-animation 25s linear infinite;
    animation: my-animation 25s linear infinite;

    /* for Firefox */
    @-moz-keyframes my-animation {
        from {
            -moz-transform: translateX(100%);
        }
        to {
            -moz-transform: translateX(-250%);
        }
    }

    /* for Chrome */
    @-webkit-keyframes my-animation {
        from {
            -webkit-transform: translateX(100%);
        }
        to {
            -webkit-transform: translateX(-250%);
        }
    }

    @keyframes my-animation {
        from {
            -moz-transform: translateX(100%);
            -webkit-transform: translateX(100%);
            transform: translateX(100%);
        }
        to {
            -moz-transform: translateX(-270%);
            -webkit-transform: translateX(-250%);
            transform: translateX(-250%);
        }
    }

    @media only screen and (max-width: 1200px) {
        /* for Firefox */
        @-moz-keyframes my-animation {
            from {
                -moz-transform: translateX(100%);
            }
            to {
                -moz-transform: translateX(-700%);
            }
        }

        /* for Chrome */
        @-webkit-keyframes my-animation {
            from {
                -webkit-transform: translateX(100%);
            }
            to {
                -webkit-transform: translateX(-700%);
            }
        }

        @keyframes my-animation {
            from {
                -moz-transform: translateX(100%);
                -webkit-transform: translateX(100%);
                transform: translateX(100%);
            }
            to {
                -moz-transform: translateX(-700%);
                -webkit-transform: translateX(-700%);
                transform: translateX(-700%);
            }
        }
`;

const BannerTextScroll = ({ message }) => {
   const { isMobile } = useBreakpoint();

   return (
      <ScrollContainer isMobile={isMobile}>
         <ScrollText>
            🔧 <TextCapitalize>Maintenance des applications : </TextCapitalize> {message}
         </ScrollText>
      </ScrollContainer>
   );
};

export default BannerTextScroll;
